/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBLEVELLIST = 'GETCLUBLEVELLIST'



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/constants.js